module.exports = __webpack_public_path__ + "img/sutherapy_02.2319a404.jpg";